import type { IconSvgObject } from './types';

const CreditCardNotAcceptIcon: IconSvgObject = [
  ["path", { d: "M22 20L16 14M22 14L16 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 9H22M12.5 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6L22 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CreditCardNotAcceptIcon;
